window.onload = function() {
  if($('#innerVideo').length) {
    setTimeout(function(){
      document.getElementById('innerVideo').play(); 
    },500);
  }
};
$(document).ready(function(e) {

  function closePopup() {
    $('.popupOverlay').fadeOut('slow');
    $('.popupBox .cls_popup').remove();
  }
  function openPopup(a) {
    $('.popupOverlay.'+a).fadeIn('slow');
    $('.popupBox').append('<a class="cls_popup" >X</a>');
  }
  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
    if (!$(e.target).closest('.userMenu').length){
      $('.userMenu ul').slideUp();
    }
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });
  
  $('.userMenu > a').on('click', function(e){
    e.preventDefault();
    $('.userMenu').find('ul').slideToggle();
  });
  
    $('.openQv').on('click', function(e){
      $(this).attr('disabled','disabled');
      $('.qvProduct').removeAttr('style');
      var url = $(this).attr("href")+'?view=quick_view';
      e.preventDefault();
      $.get( url, function( data ) {
        $('#qvProductContent').html(data);
        openPopup('qvPopup');
        $('.puList').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false
        });
         
        $('.qv_main').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.qv_thumb'
        });
        $('.qv_thumb').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: '.qv_main',
          dots: false,
          focusOnSelect: true,
          arrows: true,
        });
        
        $('.addtocartForm').on('submit', function(e){
          e.preventDefault();
          $('#add-to-cart').attr('disabled');
          $('#add-to-cart span').text('Adding..');
          var form = $(this);
          $('.puadd:checked').each(function(){
            var id = $(this).attr('data-id');
            $.ajax({
              url: '/cart/add.js',
              data: { id: id },
              type: 'POST',
              dataType: 'json',
              async:false
            });
          });
          $.ajax({
            url: '/cart/add.js',
            data: form.serialize(),
            type: 'POST',
            dataType: 'json',
            async:false,
            success: function(){
              $('#add-to-cart').removeAttr('disabled');
              $('#add-to-cart span').text('Added.');
              //closePopup();
            }
          });
        });
        
      });
      $('.openQv').removeAttr('disabled');
    });
  
  
  $('.pro-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow:3,
    slidesToScroll:1,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 993,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        }
      }
    ]
  });
  $('.review-slide').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow:1,
    slidesToScroll:1,
    //adaptiveHeight: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 95000,
  });

  $('.site-del .open').on('click', function(e){
    e.preventDefault();
    setTimeout(function(){ 
      $('body').addClass('menuOpen');
      $('.full-content').addClass('contentPush');
    }, 50);

  });
  $('body').on('click', '.close, .contentPush.full-content', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.full-content').removeClass('contentPush');
  });

  $(".mmenu-bar ul li .toggleItem").click(function(e){
    e.preventDefault();
    if ( $(this).closest('li').hasClass('active')){
      $(".mmenu-bar ul li").removeClass("active");
      $(".mmenu-bar ul li ul").slideUp(300);			
    } else {
      $(".mmenu-bar ul li").removeClass("active");
      $(this).closest('li').addClass('active'); 
      $(".mmenu-bar ul li ul").slideUp(300);		
      $(".mmenu-bar ul li.active ul").slideToggle(300);
    }
  });

  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if(scroll > 60) {
      $(".main-header").addClass("DarkHeader");
    } else {
      $(".main-header").removeClass("DarkHeader");
    }
    if(scroll > 190) {
      $(".nav").addClass("fixed");
    } else {
      $(".nav").removeClass("fixed");
    }

  });

  $('.best-sale-cols').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow:4,
    slidesToScroll:1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.rel-company-col').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow:3,
    slidesToScroll:1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
        }
      }
    ]
  });
  
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  
  $('.product-main-slider').on('init', function(){
    if(window.location.pathname.split("/").pop()=='cool-flash-pad-body-pad') {
      if(getParameterByName('for')=='woman') {
        setTimeout(function(){
          $('.thumbImgs[alt="womanFlashPad"]').eq(0).trigger('click');
        },1500);
      }
    }
  }).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.product-feacture-slider'
  });
  
  $('.product-feacture-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-main-slider',
    dots: false,
    focusOnSelect: true,
    arrows: true
  });
  
  if($('.pro_749715259490').length) {
    $('.product-main-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      var alt = $('.mainImgSlide.slick-active').find('img').attr('alt');
      $('.shortDesc > div').hide();
      $('.shortDesc > div.'+alt).show();    
    });
  }
  
  
  
  $('.product-main-slider1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    adaptiveHeight: true
  });
  
  $('body').on('click', '.adjust', function(){
    var ip = parseInt($(this).parent().find('input').val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      ip = 1;
    }
    $(this).parent().find('input').val(ip);
    if($(this).closest('form').hasClass('fullcartForm')) {
      $('#cartform').submit();
    }
  });

  $('.product-head .pro-head').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.product-head .pro-head').removeClass('active');
    $('.tab-content').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  });
  
  $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    });
  



theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    
  }
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

 
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
    
  }

   
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

  $('.Faq-title').on('click',function(e){
    e.preventDefault();
    if($(this).closest('.Faq-cols').hasClass('active')){
      $('.Faq-cols').removeClass('active');
      $('.Faq-cols .Faq-Content').slideUp(300);
    } else {
      $('.Faq-cols').removeClass('active');
      $(this).closest('.Faq-cols').addClass('active');
      $('.Faq-cols .Faq-Content').slideUp(300);
      $('.Faq-cols.active .Faq-Content').slideToggle(300);
    }
  });
  
  $('.mul-col a').click(function(e){
    e.preventDefault();
    var tab_id = $(this).attr('data-tab');

    $('.mul-col a').removeClass('active');
    $('.cool-dogs .tab-contents').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  });
  
});